export const LOAN_LIBRARY_QUEUE_STATUS = {
    Pending: 1,
    Waitlist: 2,
    ReadyForProcessing: 3,
    WaitlistProcessing: 4,
    CheckedOut: 5,
    Cancelled: 6,
};

export const LOAN_LIBRARY_LOAN_STATUS = {
    ReadyForProcessing: 1,
    Processing: 2,
    CheckedOut: 3,
    WaitList: 4,
    NeedInfo: 5,
    Cancelled: 6,
    Extension: 7,
    Returned: 8,
    Lost: 9,
    Damaged: 10
};

export const loanLibraryQueueModel = ({
    loanLibraryQueueItemIds = [],
    shippingLocationId = null,
}: { loanLibraryQueueItemIds?: string[]; shippingLocationId?: string | null } = {}) => ({
    loanLibraryQueueItemIds,
    shippingLocationId,
});

export const emptyLoanLibraryQueueModel = loanLibraryQueueModel();

export const loanLibraryCatalogQueueModel = ({
    loanLibraryCatalogItemId,
    loanLibraryQueueId,
    status,
    catalogNumber,
    inventoryBarCode,
    inventoryShortId,
    studentName,
    shippingLocationName,
    productName,
    patronName,
}: Record<string, unknown> = {}) => ({
    loanLibraryCatalogItemId,
    details: createLoanLibraryQueueDetails({
        status: status as number | undefined,
        catalogNumber: catalogNumber as string | undefined,
        inventoryBarCode: inventoryBarCode as string | undefined,
        inventoryShortId: inventoryShortId as string | undefined,
        studentName: studentName as string | undefined,
        shippingLocationName: shippingLocationName as string | undefined,
        patronName: patronName as string | undefined,
    }),
    loanLibraryQueueId,
    productName,
});

function returnCatalogNumber(catalogNumber: string | null | undefined) {
    return catalogNumber ? `<div><b>${catalogNumber}</b> (Catalog #)</div>` : "";
}

function returnStatus(status: string | number | null | undefined) {
const statusText: { [key: number]: string } = {
    1: "Pending",
    2: "Waitlist",
    3: "Ready for Processing",
    4: "Waitlist Processing",   
    5: "Checked Out",
    6: "Cancelled",
};
const key = typeof status === 'number' ? status : Number(status);
const statusValue = !isNaN(key) ? statusText[key] || "Unknown" : "Unknown";
    return `<div><b>${statusValue}</b> (Status)</div>`;
}

function returnBarcode(inventoryBarCode: string | null | undefined) {
    return inventoryBarCode ? `<div><b>${inventoryBarCode}</b> (Barcode)</div>` : "";
}

function returnInventoryShortId(inventoryShortId: string | null | undefined) {
    return inventoryShortId ? `<div><b>${inventoryShortId}</b> (Item ID)</div>` : "";
}

function returnStudent(studentName: string | null | undefined) {
    return studentName ? `<div><b>${studentName}</b> (Student)</div>` : "";
}

function returnShipping(shippingLocationName: string | null | undefined) {
    return shippingLocationName ? `<div><b>${shippingLocationName}</b> (Shipping)</div>` : "";
}

function returnPatronName(patronName: string | null | undefined) {
    return patronName ? `<div><b>${patronName}</b> (Patron)</div>` : "";
}

function createLoanLibraryQueueDetails({status, catalogNumber, inventoryBarCode, inventoryShortId, studentName, shippingLocationName, patronName}: { status?: string | number | null; catalogNumber?: string | null; inventoryBarCode?: string | null; inventoryShortId?: string | null; studentName?: string | null; shippingLocationName?: string | null; patronName?: string | null }) {
    let details = "";
    details += returnPatronName(patronName);
    details += returnInventoryShortId(inventoryShortId);
    details += returnCatalogNumber(catalogNumber);
    details += returnStatus(status);
    details += returnBarcode(inventoryBarCode);
    details += returnStudent(studentName);
    details += returnShipping(shippingLocationName);
    return details;
}

export const queueItemModel = (loanLibraryQueueItem: Record<string, unknown> = {}) => {
const loanLibraryInventoryId = loanLibraryQueueItem.loanLibraryInventoryId as string | undefined;
const loanLibraryCatalogItemId = loanLibraryQueueItem.loanLibraryCatalogItemId as string | undefined;
const catalogItem = (loanLibraryQueueItem.loanLibraryCatalogItem || {}) as Record<string, unknown>;
const productName = (catalogItem.productName as string) || '';
const catalogNumber = catalogItem.catalogNumber as string | undefined;
const serialNumber = loanLibraryQueueItem.serialNumber as string | undefined;
const assetNumber = loanLibraryQueueItem.assetNumber as string | undefined;
const shelfLocation = loanLibraryQueueItem.shelfLocation as string | undefined;
const status = loanLibraryQueueItem.status as number | undefined;
const inventoryBarCode = loanLibraryQueueItem.inventoryBarCode as string | undefined;
    const inventoryShortId = (loanLibraryQueueItem.inventoryShortId as string) || '';
    const shippingLocationName = loanLibraryQueueItem.shippingLocationName as string | undefined;
    const patronName = (loanLibraryQueueItem.patronName as string) || '';

    const loanLibraryQueueId = (loanLibraryQueueItem.loanLibraryQueueId as string) || '';

    return {
        ...loanLibraryQueueItem,
        loanLibraryQueueId,
        loanLibraryInventoryId,
        loanLibraryCatalogItemId,
        productName,
        catalogNumber,
        serialNumber,
        assetNumber,
        shelfLocation,
        inventoryBarCode,
        inventoryShortId,
        shippingLocationName,
        patronName,
        status,
        isPending: status === LOAN_LIBRARY_QUEUE_STATUS.Pending || status === LOAN_LIBRARY_QUEUE_STATUS.Waitlist,
        isWaitlisted: status === LOAN_LIBRARY_QUEUE_STATUS.Waitlist,
        isReadyForProcessing: status === LOAN_LIBRARY_QUEUE_STATUS.ReadyForProcessing,
        canAssignShipping: status === LOAN_LIBRARY_QUEUE_STATUS.Pending,
        hasInventoryReserved: loanLibraryInventoryId != null,
    };
};
